<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <div class="row pb-4">
            <div class="col">
              <h3 class="p-0">FRT Rates Procurement Administration</h3>
            </div>
            <div class="col text-right">
              <div class="dropdown">
                <button type="button" class="btn btn-outline-secondary btn-more w-auto rounded-circle" id="more-options" data-toggle="dropdown" aria-label="More Options" aria-haspopup="true" aria-expanded="false">
                  <span class="ellipsis" aria-hidden="true">&#8943;</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <h6 class="dropdown-header text-uppercase px-4">More Options</h6>
                  <a class="dropdown-item" routerLink="/ratefiletspext" routerLinkActive="active">Extend Closing Date</a>
                </div>
              </div>
            </div>
          </div>

          @if (updateSuccessful && !createFlag) {
            <div class="alert alert-success">
              Your Rate Filing dates have been successfully updated.
            </div>
          }
          @if (updateSuccessful && createFlag) {
            <div class="alert alert-success">
              Your Rate Filing dates have been successfully created.
            </div>
          }
          @if (!createFlag && !updateSuccessful) {
            <div class="alert alert-success">
              A rate record is in Pending state. Please select from the list to maintain it.
            </div>
          }
          @if (createFlag && (!valueChanged)) {
            <div class="alert alert-success">
              All rates are released. To create new please select exisitng one and modify or enter new data.
            </div>
          }
          @if (updateFailure) {
            <div class="alert alert-danger">
              An error has occurred. Please contact support.
            </div>
          }
          @if (valSaveError) {
            <div class="alert alert-danger">
              {{saveErrorMsg}}
            </div>
          }
          <form [formGroup]="rateFileOpenForm" >

            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="bidCycle">Bid Cycle Name</label>
                <input type="text" id="bidCycle" class="w-100" formControlName="bidCycle"
                  (change) = "onCycleNameChange($event)"
                  >
                @if (this.rateFileOpenForm.get('bidCycle').invalid && this.rateFileOpenForm.get('bidCycle').touched || this.rateFileOpenForm.get('bidCycle').dirty) {
                  <div>
                    @if (this.rateFileOpenForm.get('bidCycle').hasError('required')) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> Bid Cycle Name is required
                      </div>
                    }
                  </div>
                }
                <input type="text" class="d-none" formControlName="controlId">
                <input type="text" class="d-none" formControlName="rateKey">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="open_date">Rate Filing Open Date</label>
                <input type="text" id="open_date" class="w-100" placeholder="mm/dd/yyyy"
                  formControlName="openDate"
                  (bsValueChange)="openDateChange($event)" [minDate]="openMinDate"
                  [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                  [value]="this.rateFileOpenForm.get('openDate').value | date: 'MMM d, y'"
                  bsDatepicker placement="right">

                @if (this.rateFileOpenForm.get('openDate').invalid && this.rateFileOpenForm.get('openDate').touched || this.rateFileOpenForm.get('openDate').dirty) {
                  <div>
                    @if (this.rateFileOpenForm.get('openDate').hasError('required')) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> Open Date is required
                      </div>
                    }
                  </div>
                }

                @if (this.rateFileOpenForm.get('openDate').invalid &&
                  this.rateFileOpenForm.get('openDate').touched ||
                  this.rateFileOpenForm.get('openDate').dirty) {
                  <div>
                    @if (this.openDateError1) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{openDateErrorMsg1}}
                      </div>
                    }
                    @if (this.openDateError2) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{openDateErrorMsg2}}
                      </div>
                    }
                    @if (this.openDateError3) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{openDateErrorMsg3}}
                      </div>
                    }
                    @if (this.openDateError4) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{openDateErrorMsg4}}
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="form-group col-md-4">
                <label for="close_date">Rate Filing Close Date</label>
                <input type="text" id="close_date" class="w-100" placeholder="mm/dd/yyyy"
                  formControlName="closeDate" (bsValueChange)="closeDateChange($event)"
                  [minDate]="closeMinDate" [value]="this.rateFileOpenForm.get('closeDate').value | date: 'MMM d, y'"
                  [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                  bsDatepicker [bsConfig]="datePickerConfig" placement="right">

                @if (this.rateFileOpenForm.get('closeDate').invalid &&
                  this.rateFileOpenForm.get('closeDate').touched ||
                  this.rateFileOpenForm.get('closeDate').dirty) {
                  <div>
                    @if (this.rateFileOpenForm.get('closeDate').hasError('required')) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> Close Date is required
                      </div>
                    }
                    @if (this.closeDateError1) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{closeDateErrorMsg1}}
                      </div>
                    }
                    @if (this.closeDateError2) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{closeDateErrorMsg2}}
                      </div>
                    }
                    @if (this.closeDateError3) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{closeDateErrorMsg3}}
                      </div>
                    }
                    @if (this.closeDateError4) {
                      <div class="text-danger">
                        <span class="fa fa-warning"></span> {{closeDateErrorMsg4}}
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="form-group col-md-4">
                <label for="release_to_prod">Release to Production</label>
                <input type="text" id="release_to_prod" class="w-100"
                  [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                  placeholder="mm/dd/yyyy" formControlName="releaseDate"
                  (bsValueChange)="releaseDateChange($event)"
                  [value]="this.rateFileOpenForm.get('releaseDate').value | date: 'MMM d, y'"
                  bsDatepicker [bsConfig]="datePickerConfig" placement="left">

                  @if (this.rateFileOpenForm.get('releaseDate').invalid && this.rateFileOpenForm.get('releaseDate').touched || this.rateFileOpenForm.get('releaseDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('releaseDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> Release Date is required
                        </div>
                      }
                      @if (this.releaseDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{releaseDateErrorMsg1}}
                        </div>
                      }
                      @if (this.releaseDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{releaseDateErrorMsg2}}
                        </div>
                      }
                      @if (this.releaseDateError3) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{releaseDateErrorMsg3}}
                        </div>
                      }
                      @if (this.releaseDateError4) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{releaseDateErrorMsg4}}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="tsp_open_date">TSP Participation Open Date</label>
                  <input type="text" id="tsp_open_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="tspOpenDate"
                    (bsValueChange)="tspOpenDateChange($event)" [minDate]="tspOpenMinDate"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    [value]="this.rateFileOpenForm.get('tspOpenDate').value | date: 'MMM d, y'"
                    bsDatepicker placement="right">

                  @if (this.rateFileOpenForm.get('tspOpenDate').invalid &&
                    this.rateFileOpenForm.get('tspOpenDate').touched ||
                    this.rateFileOpenForm.get('tspOpenDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('tspOpenDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span>TSP Participation Open Date is required
                        </div>
                      }
                    </div>
                  }

                  @if (this.rateFileOpenForm.get('tspOpenDate').invalid &&
                    this.rateFileOpenForm.get('tspOpenDate').touched ||
                    this.rateFileOpenForm.get('tspOpenDate').dirty) {
                    <div>
                      @if (this.tspOpenDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{tspOpenDateErrorMsg1}}
                        </div>
                      }
                      @if (this.tspOpenDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{tspOpenDateErrorMsg2}}
                        </div>
                      }
                      @if (this.tspOpenDateError3) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{tspOpenDateErrorMsg3}}
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="form-group col-md-4">
                  <label for="close_date">TSP Participation Close Date</label>
                  <input type="text" id="tsp_close_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="tspCloseDate" (bsValueChange)="tspCloseDateChange($event)"
                    [minDate]="tspCloseMinDate"
                    [value]="this.rateFileOpenForm.get('tspCloseDate').value | date: 'MMM d, y'"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    bsDatepicker [bsConfig]="datePickerConfig" placement="right">

                  @if (this.rateFileOpenForm.get('tspCloseDate').invalid &&
                    this.rateFileOpenForm.get('tspCloseDate').touched ||
                    this.rateFileOpenForm.get('tspCloseDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('tspCloseDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> TSP Participation Close Date is required
                        </div>
                      }
                      @if (this.tspCloseDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{tspCloseDateErrorMsg1}}
                        </div>
                      }
                      @if (this.tspCloseDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{tspCloseDateErrorMsg2}}
                        </div>
                      }
                      @if (this.tspCloseDateError3) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{tspCloseDateErrorMsg3}}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="eff_open_date">Rate Effective Date</label>
                  <input type="text" id="eff_open_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="effOpenDate"
                    (bsValueChange)="effOpenDateChange($event)" [minDate]="effOpenMinDate"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    [value]="this.rateFileOpenForm.get('effOpenDate').value | date: 'MMM d, y'"
                    bsDatepicker placement="right">

                  @if (this.rateFileOpenForm.get('effOpenDate').invalid &&
                    this.rateFileOpenForm.get('effOpenDate').touched ||
                    this.rateFileOpenForm.get('effOpenDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('effOpenDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span>Effective Date Open Date is required
                        </div>
                      }
                    </div>
                  }

                  @if (this.rateFileOpenForm.get('effOpenDate').invalid &&
                    this.rateFileOpenForm.get('effOpenDate').touched ||
                    this.rateFileOpenForm.get('effOpenDate').dirty) {
                    <div>
                      @if (this.effOpenDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{effOpenDateErrorMsg1}}
                        </div>
                      }
                      @if (this.effOpenDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{effOpenDateErrorMsg2}}
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="form-group col-md-4">
                  <label for="eff_close_date">Rate Expiry Date</label>
                  <input type="text" id="eff_close_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="effCloseDate" (bsValueChange)="effCloseDateChange($event)"
                    [minDate]="effCloseMinDate"
                    [value]="this.rateFileOpenForm.get('effCloseDate').value | date: 'MMM d, y'"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    bsDatepicker [bsConfig]="datePickerConfig" placement="right">

                  @if (this.rateFileOpenForm.get('effCloseDate').invalid &&
                    this.rateFileOpenForm.get('effCloseDate').touched ||
                    this.rateFileOpenForm.get('effCloseDate').dirty) {
                    <div>
                      @if (this.rateFileOpenForm.get('effCloseDate').hasError('required')) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> Effective Date Close Date is required
                        </div>
                      }
                      @if (this.effCloseDateError1) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{effCloseDateErrorMsg1}}
                        </div>
                      }
                      @if (this.effCloseDateError2) {
                        <div class="text-danger">
                          <span class="fa fa-warning"></span> {{effCloseDateErrorMsg2}}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>

              @if (this.rateFileOpenForm.get('openDate').value !== '' || this.rateFileOpenForm.get('closeDate').value !== '' || this.rateFileOpenForm.get('releaseDate').value !== '') {
                <div class="mt-4">
                  <div class="mt-4">
                    <button type="button" class="btn btn-primary w-auto" [disabled]="this.rateFileOpenForm.invalid || this.updateSuccessful || this.buttonDisable || this.validationError || this.valSaveError" (click)="SaveRateFileRec()">{{saveButtonText}}</button>
                    <button type="button" class="btn btn-outline-secondary w-auto ml-4 " [disabled]="(this.rateFileOpenForm.get('openDate').value === '' || this.rateFileOpenForm.get('closeDate').value === '' || this.rateFileOpenForm.get('releaseDate').value === '')" (click)="clearPage()">Cancel</button>
                  </div>
                </div>
              }
            </form>
          </div>
        </div>
        <div class="card shadow-sm mt-5" >
          <div class="card-body p-5">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Bid Cycle Name</th>
                  <th>Open Date</th>
                  <th>Close Date</th>
                  <th>Release to Production</th>
                </tr>
              </thead>
              <tbody>
                @for (rateFileDetail of rateFileDetails; track rateFileDetail; let i = $index) {
                  <tr>
                    <td><a  [routerLink]="[]"  (click)="selectedRecord(rateFileDetail.controlId, i)"
                    >{{rateFileDetail.cycleName}}</a></td>
                    <td>{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</td>
                    <td>{{rateFileDetail.expiryDate | date: 'M/d/y'}}</td>
                    <td>{{rateFileDetail.releaseDate | date: 'M/d/y'}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
